import { useChartContextContext } from './chartContext';
import { useDrawLines, UseDrawLinesOptions } from './useDrawLines';

export const DrawLines = ({
  tradingPair,
  orders,
  positions,
  tpSl,
  openTrade,
}: Omit<UseDrawLinesOptions, 'chartApi' | 'isChartReady'>) => {
  const { chartApi, isChartReady } = useChartContextContext();
  useDrawLines({
    openTrade,
    tradingPair,
    orders,
    positions,
    tpSl,
    chartApi,
    isChartReady,
  });

  return <></>;
};
